import { render, staticRenderFns } from "./marketplace-item-detail.vue?vue&type=template&id=666043f4&"
import script from "./marketplace-item-detail.vue?vue&type=script&lang=js&"
export * from "./marketplace-item-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports